import React from 'react';

import { createComponent, Layout, Header, Label, enums, PropTypes } from 'console-kit';

import authStatics from '../../../common/static';
import AuthImageLogo from '../../../components/AuthImageLogo';

const ImpossiblePanel = createComponent({
  displayName: 'ImpossiblePanel',
  propTypes:   {
    loginLink: PropTypes.string,
  },
  defaultProps: {
    loginLink: '',
  },
  render(props) {
    return (
      <div className={authStatics.SCREEN_CLASSES}>
        <Layout isFluidHeight>
          <Layout.Row>
            <Layout.Column textAlign={enums.textAlignments.CENTER}>
              <AuthImageLogo />
            </Layout.Column>
          </Layout.Row>

          <Layout.Row>
            <Layout.Column textAlign={enums.textAlignments.LEFT}>
              <Header
                text="Error signing in"
                isDividing={false}
                font={{
                  emphasis: enums.font.emphasis.NORMAL,
                }}
                size={enums.sizes.X6}
              />
            </Layout.Column>
          </Layout.Row>

          <Layout.Row>
            <Layout.Column textAlign={enums.textAlignments.LEFT}>
              <Label
                text={<span>You’ve not migrated to Marigold ID yet. Please login directly into <a href={props.loginLink}>Experiences</a>.</span>}
                hasPadding={false}
                isFluid
              />
            </Layout.Column>
          </Layout.Row>

        </Layout>
      </div>
    );
  },
});

export default ImpossiblePanel;
